import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useSEO } from "../lib/useSEO";
import { Droplets } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useSEO({ title: "Admin Login | WaterfallFinder" });

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center bg-stone-50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white border border-stone-200 shadow-sm p-8">
        <div className="flex items-center gap-2 font-display text-xl font-bold text-[hsl(var(--primary))] mb-6">
          <Droplets className="w-6 h-6 text-[hsl(var(--accent))]" />
          WaterfallFinder Admin
        </div>
        <h1 className="font-display text-2xl font-bold mb-2">Sign in</h1>
        <p className="text-sm text-stone-600 mb-6">Admin access only.</p>
        <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-1">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email-input"
              className="w-full rounded-lg border border-stone-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[hsl(var(--primary))]"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-1">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
              className="w-full rounded-lg border border-stone-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[hsl(var(--primary))]"
            />
          </div>
          {error && (
            <p className="text-sm text-red-600" data-testid="login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="btn-pill w-full bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--moss))] disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
}
